import { render, staticRenderFns } from "./Formation.vue?vue&type=template&id=af375d0e&scoped=true&"
import script from "./Formation.vue?vue&type=script&lang=js&"
export * from "./Formation.vue?vue&type=script&lang=js&"
import style0 from "./Formation.vue?vue&type=style&index=0&id=af375d0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af375d0e",
  null
  
)

export default component.exports